class h {
  events;
  hOP;
  constructor() {
    this.events = {}, this.hOP = this.events.hasOwnProperty;
  }
  subscribe(s, t) {
    this.hOP.call(this.events, s) || (this.events[s] = []);
    var e = this.events[s].push(t) - 1;
    return {
      remove: () => {
        delete this.events[s][e];
      }
    };
  }
  publish(s, t) {
    this.hOP.call(this.events, s) && this.events[s].forEach(function(e) {
      e(t !== void 0 ? t : {});
    });
  }
}
const n = new h();
export {
  n as default
};
